import React from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { Social } from './Social'

function getModalStyle() {
  const top = 0//50 + rand();
  const left = 0//50 + rand();

  return {
    top: 0,
    left: 0,
    transform: `translate(-${0}%, -${left}%)`,
  };
}

const styles = theme => ({
  paper: {

    display: 'flex',
    flexDirection: 'column',
  },
});

class SimpleModal extends React.Component {
  constructor() {
    super()
    this.state = {
      open: false,
    };
    this.HandleClose = this.HandleClose.bind(this)
  }
  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  HandleClose() {
    return this.handleClose
  }

  componentDidMount() {
    document.addEventListener("backbutton", this.handleClose, false);

  }
  render() {
    const { classes } = this.props;

    const children = this.props.children;

    const childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, { handleClose: this.handleClose }));

    if (this.state.open === true) {
      var openclose = this.handleClose
      var icon = this.props.iconClose
      var zInd = { zIndex: 1301, position: 'absolute', top: '15px', left: '20px' }
    
  } else {
  var openclose = this.handleOpen
  var icon = this.props.icon
}

return (
  <div >

    <a onClick={openclose} className="IconBtn" style={zInd}><img className="Icon" src={icon} /></a>
    <ReactCSSTransitionGroup
      transitionName="modalTransition"
      transitionAppear={true}
      transitionAppearTimeout={800}
      transitionEnterTimeout={500}
      transitionLeaveTimeout={1000}>
      <Modal
        className="MyModal"
        open={this.state.open}
        onClose={this.handleClose}
        disableAutoFocus={true}

      >
        <div style={getModalStyle()} className={classes.paper}>

          {childrenWithProps}
          <MyModal />
          <Social modal={true} />
        </div>
      </Modal>
    </ReactCSSTransitionGroup>
  </div>
);
  }
}

SimpleModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

// We need an intermediary variable for handling the recursive nesting.
const MyModal = withStyles(styles)(SimpleModal);

export default MyModal;



// WEBPACK FOOTER //
// ./src/components/MyModal.js